import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Chip,
  LinearProgress,
  Alert,
  Button,
  Stack,
  Tabs,
  Tab
} from '@mui/material';
import {
  WorkOutline as ProjectIcon,
  Timeline as TimelineIcon,
  PhotoLibrary as GalleryIcon
} from '@mui/icons-material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

/**
 * Client Projects Main Page
 * Provides navigation to different project views (active, timeline, gallery)
 */
const ClientProjects: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(0);

  // Update active tab based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/active')) setActiveTab(0);
    else if (path.includes('/timeline')) setActiveTab(1);
    else if (path.includes('/gallery')) setActiveTab(2);
    else setActiveTab(0); // default to active
  }, [location.pathname]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    const routes = ['active', 'timeline', 'gallery'];
    navigate(`/dashboard/client/projects/${routes[newValue]}`);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          My Projects
        </Typography>
        <Typography variant="body1" color="text.secondary">
          View and manage your projects across different perspectives
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="project views"
            sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
          >
            <Tab
              label="Active Projects"
              icon={<ProjectIcon />}
              iconPosition="start"
            />
            <Tab
              label="Timeline View"
              icon={<TimelineIcon />}
              iconPosition="start"
            />
            <Tab
              label="Project Gallery"
              icon={<GalleryIcon />}
              iconPosition="start"
            />
          </Tabs>

          <Outlet />
        </CardContent>
      </Card>
    </Container>
  );
};

export default ClientProjects;